var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcProfilePerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0002 3.33398C8.1585 3.33398 6.66683 4.82565 6.66683 6.66732C6.66683 8.50898 8.1585 10.0007 10.0002 10.0007C11.8418 10.0007 13.3335 8.50898 13.3335 6.66732C13.3335 4.82565 11.8418 3.33398 10.0002 3.33398ZM11.7502 6.66732C11.7502 5.70065 10.9668 4.91732 10.0002 4.91732C9.0335 4.91732 8.25016 5.70065 8.25016 6.66732C8.25016 7.63398 9.0335 8.41732 10.0002 8.41732C10.9668 8.41732 11.7502 7.63398 11.7502 6.66732ZM15.0835 14.1673C15.0835 13.634 12.4752 12.4173 10.0002 12.4173C7.52516 12.4173 4.91683 13.634 4.91683 14.1673V15.084H15.0835V14.1673ZM3.3335 14.1673C3.3335 11.9507 7.77516 10.834 10.0002 10.834C12.2252 10.834 16.6668 11.9507 16.6668 14.1673V16.6673H3.3335V14.1673Z",
    fill: "#223A5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProfilePerson);
export default __webpack_public_path__ + "static/media/ic-profile-person.9b7ccbf3c819d5d750e14e9049592de9.svg";
export { ForwardRef as ReactComponent };